import { z } from "zod";

import { touchpointsReportSchema } from "./touchpoints-report-schema";

export const reportDataSchema = z.discriminatedUnion("type", [
  touchpointsReportSchema,
]);
